import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import { getSoleTraderInitialValues } from '../utils';
import { validationSchemaSoleTraderGeneralInfo } from '../validationSchema.ts';
import * as yup from 'yup';
import { cloneDeep } from 'lodash';
import { TGeneralInfoSoleTrader } from '../types';
import { selectGeneralInfo } from '~/store/identification-form/selectors.ts';

export const useGeneralInfoSoleTraderForm = () => {
  const generalInfo = useSelector(selectGeneralInfo);

  const initialValues = getSoleTraderInitialValues(generalInfo as TGeneralInfoSoleTrader);

  const schema = yup.lazy(() => validationSchemaSoleTraderGeneralInfo);

  const form = useForm<TGeneralInfoSoleTrader>({
    resolver: yupResolver(schema) as unknown as Resolver<TGeneralInfoSoleTrader>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: cloneDeep(initialValues),
  });

  return form;
};
